import React, { useState, useEffect, useRef } from 'react';
import Card from '@/components/ui/cards/Card';
import CardHeader from '@/components/ui/cards/CardHeader';
import CardBody from '@/components/ui/cards/CardBody';
import { InputDatepicker } from '@/components/ui/inputs/input-datepicker';
import { getOrdersService } from '@/services/DashboardServices';
import validationErrors from '@/lib/validationErrors';
import { useSelector, useDispatch } from 'react-redux';
import { Line, Bar } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, BarElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend, Title } from 'chart.js';

ChartJS.register(LineElement, BarElement, PointElement, CategoryScale, LinearScale, Tooltip, Legend, Title);

const CustomerStatsComponent = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const today = new Date();
    const oneMonthFromToday = new Date();
    oneMonthFromToday.setMonth(today.getMonth() - 1);
    const [dateRangeSelect, setDateRangeSelect] = useState({ start_date: oneMonthFromToday, end_date: today });
    const [chartData, setChartData] = useState({
        labels: [], // Dynamic labels
        datasets: [
            {
                label: 'Orders',
                data: [], // Dynamic data
                backgroundColor: 'rgba(75, 192, 192, 0.5)', // Bar color
                borderColor: 'rgba(75, 192, 192, 1)', // Border color
                borderWidth: 1,
            },
        ],
    });

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Order Report',
            },
        },
    };

    const handleDateChange = (dates) => {
        const [start, end] = dates;
        setDateRangeSelect({ start_date: start, end_date: end });
    };

    useEffect(() => {
        if (dateRangeSelect?.start_date && dateRangeSelect?.end_date) {
            getOrdersData(dateRangeSelect);
        }
    }, [dateRangeSelect?.start_date, dateRangeSelect?.end_date]);

    const getOrdersData = (data) => {
        setIsLoading(true);
        dispatch(getOrdersService(data))
            .then((res) => {
                setDataSource(res?.data?.data);
                const dynamicLabels = res?.data?.data?.times;
                const dynamicData = res?.data?.data?.total_customers;
                setChartData({
                    labels: dynamicLabels,
                    datasets: [
                        {
                            label: 'Orders',
                            data: dynamicData,
                            backgroundColor: 'rgba(75, 192, 192, 0.5)', // Bar color
                            borderColor: 'rgba(75, 192, 192, 1)', // Border color
                            borderWidth: 1,
                        },
                    ],
                });
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    return (
        <Card>
            <CardHeader isBorder={true}>
                <h3 className="db-card-title">Order Stats</h3>
                <InputDatepicker
                    iconClassName="flex items-center me-3"
                    selected={dateRangeSelect?.start_date}
                    onChange={handleDateChange}
                    startDate={dateRangeSelect?.start_date}
                    endDate={dateRangeSelect?.end_date}
                    selectsRange
                    suffixIcon={<i className="lab lab-calendar lab-font-size-24 lab-color-pink"></i>}
                    size="sm"
                />
            </CardHeader>
            <CardBody>
                <div id="column-chart">
                    <Bar data={chartData} options={options} />
                </div>
            </CardBody>
        </Card>
    );
};

export default CustomerStatsComponent;
